import ContractionWorksheet from "../../components/ClassOne/English/ChooseFullForm";
import CorrectContractionMistakesWorksheet from "../../components/ClassOne/English/RewriteContractions";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/english/contractions/choose-full-form", title: "Choose Full Form", component: ContractionWorksheet },
    { url: "/class-one/english/contractions/rewrite-the-sentence", title: "Rewrite the Sentence", component: CorrectContractionMistakesWorksheet },
];


export default topics;